/* Rotating sitewide review strip — see sections/review-strip.liquid.
   Cross-fades between curated review blocks, pauses on hover/focus, and
   respects prefers-reduced-motion. No dependencies. */
(function () {
  function initCarousel(root) {
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-review-slide]'));
    if (slides.length < 2) {
      return;
    }

    var dotWrap = root.querySelector('[data-review-dots]');
    var interval = parseInt(root.getAttribute('data-interval'), 10);
    if (!interval || interval < 2000) {
      interval = 6000;
    }

    var index = 0;
    var timer = null;
    var dots = [];

    if (dotWrap) {
      slides.forEach(function (slide, i) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'review-strip__dot';
        dot.setAttribute('aria-label', 'Show review ' + (i + 1) + ' of ' + slides.length);
        if (i === 0) {
          dot.setAttribute('aria-current', 'true');
        }
        dot.addEventListener('click', function () {
          show(i);
          restart();
        });
        dotWrap.appendChild(dot);
        dots.push(dot);
      });
    }

    function show(next) {
      var target = ((next % slides.length) + slides.length) % slides.length;
      if (target === index) {
        return;
      }
      slides[index].classList.remove('is-active');
      slides[index].setAttribute('aria-hidden', 'true');
      if (dots[index]) {
        dots[index].removeAttribute('aria-current');
      }
      index = target;
      slides[index].classList.add('is-active');
      slides[index].removeAttribute('aria-hidden');
      if (dots[index]) {
        dots[index].setAttribute('aria-current', 'true');
      }
    }

    function start() {
      if (timer) {
        return;
      }
      timer = window.setInterval(function () {
        show(index + 1);
      }, interval);
    }

    function stop() {
      window.clearInterval(timer);
      timer = null;
    }

    function restart() {
      stop();
      start();
    }

    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    root.addEventListener('focusin', stop);
    root.addEventListener('focusout', start);

    if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      start();
    }
  }

  function init() {
    var carousels = document.querySelectorAll('[data-review-carousel]');
    Array.prototype.forEach.call(carousels, initCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
